import type { Vehicle } from '../../Entities/Vehicle/Vehicle.entity';
import type { GenericVehicleListingSubset } from './ExtractGenericVehicleListingSubset.action';

export const extractVehicleListingSubset = async (
  vehicle: Vehicle | GenericVehicleListingSubset,
) => {
  return {
    ...(vehicle.dealer && { dealer: { id: vehicle.dealer.id } }),
    spec: {
      bodyType: vehicle.spec.bodyType,
      color: vehicle.spec.color,
    },
    details: {
      stockCondition: vehicle.details.stockCondition,
      createdAt: vehicle.details.createdAt,
      mileage: vehicle.details.mileage,
      registration: vehicle.details.registration,
      year: vehicle.details.year,
      status: vehicle?.details.status,
    },
    heycarId: vehicle.heycarId,
    make: { label: vehicle.make.label },
    model: { label: vehicle.model.label },
    pricing: {
      monthlyPrice: vehicle.pricing.monthlyPrice,
      price: vehicle.pricing.price,
    },
    ...(vehicle.variant && { variant: { label: vehicle.variant.label } }),
    prettyName: vehicle.prettyName,
    vin: vehicle.vin,
  };
};

export type VehicleListingSubset = Awaited<ReturnType<typeof extractVehicleListingSubset>>;
